function init_dobbleanim(from_php){
    var main=$(".place.dobbleanim");
    var canvWrap=main.find(".canvWrap");
    var canv=main.find("#canvQJS");
    
    var mapCur,zoomCur;
    var wasLoaded=0;
    
    var resources={};
    
    if(_ON_DEV){
        console.log(from_php);
    }
    
    if(typeof from_php.girl_ids=="undefined" ||  from_php.girl_ids.length==0){
        return false;
    }
    var app = new PIXI.Application({
        width: 1280, height: 780,antialias: true,transparent:true,
        view:canv[0]
    });
    var loaderSemaphore= new mySemaphore({timeout:0});
    loaderSemaphore.use(1);
    
    var textObj;
    
    $.addToPlacePreloader(function(){
            //on load
//        _moduleEvents.trigger("loadEnd");
    },[],{addToLoader:1});
    //9
    
    var girl_layers=[
        "anim_10","anim_9","anim_8","anim_6","anim_0","anim_1","anim_2",
        "anim_4","anim_3","anim_7","anim_5",
        
        "winona","maggie","indira","geeky","victoria","linn","anya","alice","zoe","twins",
        "ice","sanshi","emma","pantress","premium","dora",
        "frecly","lola","cindy","cherry","ashley"
    ];
    girl_layers.reverse();
    
    var conf_anim=[
        {id:"0",anim_arr:["animation"],girl_names:["premium","cherry"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/cherry_premium/skeleton.json"},
        {id:"1",anim_arr:["animation"],girl_names:["premium","cherry","lola"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/cherry_lola_premium/skeleton.json"},
        {id:"2",anim_arr:["animation"],girl_names:["premium","cherry","lola","sanshi"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/cherry_lola_premium_sanshi/skeleton.json"},
        {id:"3",anim_arr:["animation","animation2"],girl_names:["alice","anya","linn"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/alice_linn_anya/skeleton.json"},
        {id:"4",anim_arr:["animation"],girl_names:["ashley","indira"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/ashley_indira/skeleton.json"},
        {id:"5",anim_arr:["animation","animation2","animation3"],girl_names:["emma","cindy"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/emma_cindy/skeleton.json"},
        {id:"6",anim_arr:["animation","animation2"],girl_names:["frecly","dora"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/frecly_dora/skeleton.json"},
        {id:"7",anim_arr:["animation","animation2"],girl_names:["geeky","ice"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/geeky_ice/skeleton.json"},
        {id:"8",anim_arr:["animation","animation2"],girl_names:["maggie","winona"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/maggie_winona/skeleton.json"},
        {id:"9",anim_arr:["animation","animation2"],girl_names:["pantress","victoria"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/pantress_victoria/skeleton.json"},
        {id:"10",anim_arr:["animation"],girl_names:["twins","zoe"],url:_IMG_SERV+"/gfx/place/dobbleanim/anims/twins_zoe/skeleton.json"}
    ];
    
    

    
    
    var conf_all={
        alice:{pos:[546,1189],size:[233,505]},
        anya:{pos:[127,1222],size:[516,474]},
        ashley:{pos:[1367,538],size:[349,517]},
        cherry:{pos:[488,459],size:[342,519]},
        cindy:{pos:[402,456],size:[218,548]},
        dora:{pos:[730,1246],size:[424,428]},
        emma:{pos:[340,182],size:[562,355]},
        frecly:{pos:[763,1114],size:[292,529]},
        geeky:{pos:[1079,797],size:[354,457]},
        ice:{pos:[1268,727],size:[327,511]},
        indira:{pos:[1479,513],size:[305,586]},
        linn:{pos:[497,1365],size:[202,429]},
        lola:{pos:[706,638],size:[276,501]},
        maggie:{pos:[1262,1119],size:[462,471]},
        pantress:{pos:[806,164],size:[562,446]},
        premium:{pos:[793,423],size:[231,649]},
        sanshi:{pos:[956,608],size:[288,535]},
        twins:{pos:[68,494],size:[450,649]},
        victoria:{pos:[1030,40],size:[465,473]},
        winona:{pos:[999,1328],size:[546,364]},
        zoe:{pos:[189,730],size:[199,664]},
    };
    var conf_suit={
        alice:{pos:[571,1297],size:[191,398]},
        anya:{pos:[358,1311],size:[189,185]},
        ashley:{pos:[1440,626],size:[136,189]},
        cherry:{pos:[605,589],size:[138,123]},
        cindy:{pos:[427,564],size:[123,244]},
        dora:{pos:[906,1437],size:[195,164]},
        emma:{pos:[565,288],size:[181,152]},
        frecly:{pos:[849,1254],size:[102,130]},
        geeky:{pos:[1164,950],size:[188,155]},
        ice:{pos:[1327,895],size:[160,197]},
        indira:{pos:[1588,598],size:[111,195]},
        linn:{pos:[518,1451],size:[94,133]},
        lola:{pos:[733,795],size:[124,137]},
        maggie:{pos:[1419,1193],size:[185,196]},
        pantress:{pos:[1148,301],size:[83,134]},
        premium:{pos:[867,521],size:[144,232]},
        sanshi:{pos:[1074,720],size:[116,216]},
        twins:{pos:[137,628],size:[247,188]},
        victoria:{pos:[1287,225],size:[163,208]},
        winona:{pos:[1171,1434],size:[205,176]},
        zoe:{pos:[187,940],size:[137,326]}
    };
    
    
    var covers_arr=[
//        {url:_IMG_SERV+"/gfx/place/walkanim/cover1.png",pos:[546,1285]},
    ];
    
    
    
                
    var loaderMain = new PIXI.loaders.Loader();
    var i,girl_id,girl_name;
    loaderMain.add("back",_IMG_SERV+"/gfx/place/dobbleanim/back.jpg");
    loaderMain.add("arrow",_IMG_SERV+"/gfx/ui/arrows/blue.png");
    for(i in from_php.girl_ids){
        girl_id=from_php.girl_ids[i];
        if(girl_id==0){
            girl_name="premium";
        }
        else{
            girl_name=$.takeGirlImage(girl_id);
        }
        
        
        loaderMain.add("girl"+girl_id,_IMG_SERV+"/gfx/place/dobbleanim/girls/"+girl_name+"1.png");
        loaderMain.add("girlsuit"+girl_id,_IMG_SERV+"/gfx/place/dobbleanim/girls/"+girl_name+"2.png");
        
    }
    for(i in covers_arr){
        loaderMain.add("cover_"+i,covers_arr[i].url);
    }
    loaderSemaphore.useFun(function(){
        mapCur.centerGirl(from_php.girl_id);
    });
    
    
    girlOne=function(girl_id){
        myPixiElement.container.call(this,{});
        this.girl_id=girl_id;
        var girl_name;
        if(girl_id==0){
            girl_name="premium";
        }
        else{
            girl_name=$.takeGirlImage(girl_id);
        }
        
        var girl_conf=conf_all[girl_name];
        var suit_conf=conf_suit[girl_name];
        
        this.girl_conf=girl_conf;
        
        this.girlObj=new myPixiElement.img({
            img:"girl"+girl_id,anchor:[0,0],
            pos:girl_conf.pos
        });
        this.suitObj=new myPixiElement.img({
            img:"girlsuit"+girl_id,anchor:[0,0],
            pos:suit_conf.pos
        });
        this.addChild(this.girlObj);
        this.addChild(this.suitObj);
    };
    girlOne.prototype = Object.create(myPixiElement.container.prototype);
    girlOne.prototype=$.extend(girlOne.prototype,{
        addArrow:function(){
            this.arrow=new myPixiElement.arrow({
                img:"arrow",
                scale:60,
//                angle:90,
//                is_vertical:0,
                pos:[this.girl_conf.pos[0]+this.girl_conf.size[0]/2,this.girl_conf.pos[1]+this.girl_conf.size[1]/2]
            });
            this.addChild(this.arrow);
            
        },
        myUpdate:function(delta){
            myPixiElement.custom.myUpdate.call(this,delta);
            this.suitObj.myUpdate(delta);
            if(typeof this.arrow!="undefined"){
                this.arrow.myUpdate(delta);
            }
        }
    });
    
    
    function mapZoom(conf){
        PIXI.Container.call(this,{});
        this.girlWasLoaded=[];
        
        this.backObj = new PIXI.Graphics();
        this.backObj.beginFill(0xFFFFFF);
        this.backObj.drawRect(0, 0, 1280, 780);
        
        this.animCont= new PIXI.Container();
        
        this.backCont=new myPixiElement.container({});
        
        this.backCont.alpha=0;
        this.backCont.addChild(this.backObj);
        
        
        
        this.addChild(this.animCont);
        this.addChild(this.backCont);
        this.current_state="all";
        this.fadeSemaphore=new mySemaphore({timeout:0});
        
        
    }
    mapZoom.prototype = Object.create(PIXI.Container.prototype);
    mapZoom.prototype=$.extend(mapZoom.prototype,{
        tryToLoad:function(anim_key,on_succ){
            var anim=conf_anim[anim_key];
            if(typeof resources["anim_"+anim_key]!="undefined"){
                on_succ();
                return true;
            }
            if(!loaderSemaphore.use()){
                return false;
            }
            
            this.backCont.fadeIn(25);
            
            loaderMain.add("anim_"+anim_key,anim.url,{ metadata: { spineAtlasSuffix: '.atlas'} });
            
            var thc=this;
            
            
            loaderMain.load(function(loader, r){
                var i;
                for(i in r){
                    resources[i]=r[i];
                }
                mapCur.addAnim(anim_key);
                
                
                
                loaderSemaphore.clear();
                thc.backCont.fadeOut(25);
                on_succ();
            });
            return true;
                        
        },
        
        showGirl:function(girl_name){
            var anim_key=mapCur.findAnimKey(girl_name);
            if(anim_key==-1){
                return false;
            }
            if(typeof mapCur.animObjSet["anim_"+anim_key]!="undefined"){
                return false;
            }
            
            
            var thc=this;
            this.animCont.alpha=0;
            
            
            this.fadeSemaphore.use();
            
            
            
            
            
            
            this.tryToLoad(anim_key,function(){
                thc.fadeSemaphore.clear();
            });
            
            return true;
        },
        myUpdate:function(delta){
            this.backCont.myUpdate(delta);
        }
    });
    
    function mapWalk(conf){
        PIXI.Container.call(this);
        var back_size=resources.back.texture.baseTexture;
        
        conf=$.extend(true,{
            size:[back_size.width,back_size.height],
        },conf);
        this.conf=conf;
        
        
        this.range_all=[-(conf.size[0]-1280),-(conf.size[1]-780)];
        
        this.x=this.range_all[0]/2;
        this.y=this.range_all[1]/2;
        
        this.girlObjSet={};
        this.animObjSet={};
        this.layersSet={};
        
        this.showSuits=1;
//            this.mainCointainer.x=left_all;
            
    }
    mapWalk.prototype = Object.create(PIXI.Container.prototype);
    mapWalk.prototype=$.extend(mapWalk.prototype,{
        init:function(){
            this.prepareMove();
            this.addChild(new myPixiElement.img({img:"back",anchor:[0,0]}));
            
            this.initGirls();
            
            for(i in covers_arr){
                this.addChild(new myPixiElement.img({
                    img:"cover_"+i,anchor:[0,0],
                    pos:[covers_arr[i].pos[0],covers_arr[i].pos[1]]
                }));
            }
            
        },
        initGirls:function(){
            var i,girl_id,layer;
            for(i in girl_layers){
                layer=girl_layers[i];
                if(layer.substring(0,5)=="anim_"){
                    this.layersSet[layer]=new myPixiElement.container({});  
                    this.addChild(this.layersSet[layer]);
                }
                else{
                    girl_id=this.takeGirlId(girl_layers[i]);
                    if(in_array(girl_id,from_php.girl_ids)){
                        this.girlObjSet[girl_id]=new girlOne(girl_id);  
                        this.addChild(this.girlObjSet[girl_id]);
                    }
                }
            }
            if(from_php.girl_id && from_php.arrow && this.findAnimKey($.takeGirlImage(from_php.girl_id))!=-1){
                this.girlObjSet[from_php.girl_id].addArrow();
            }
            
            
        },
        toggleSuits:function(){
            this.showSuits=(this.showSuits+1)%2;
            var i,bum;
            for(i in this.girlObjSet){
                bum=this.girlObjSet[i];
                if(this.showSuits){
                    bum.suitObj.fadeIn(50);
                }
                else{
                    bum.suitObj.fadeOut(50);
                }
            }
        },
        addAnim:function(anim_key){
//            $.qLog(anim_key+"d ");
//            console.log(resources);
            var qConf=conf_anim[anim_key];
                    
            var anim_arr=copyArray(qConf.anim_arr);

            this.animObjSet["anim_"+anim_key]=new myPixiElement.spine({
                img:"anim_"+anim_key,
                spine_conf:{
                    anim_loop:false,
                    spineResource:resources,
                    onAnimComplete:function(){
                        var i=mt_rand(0,anim_arr.length-1);
                        this.playAnim(anim_arr[i]);
                    }
                }
            });
            this.animObjSet["anim_"+anim_key].x=74;
            this.animObjSet["anim_"+anim_key].y=105;
            
            
            
            this.layersSet["anim_"+anim_key].addChild(this.animObjSet["anim_"+anim_key]);
            
            var i,qgirl_id;
            for(i in qConf.girl_names){
                
                qgirl_id=this.takeGirlId(qConf.girl_names[i]);
                this.girlObjSet[qgirl_id].alpha=0;
            }
            
        },
        takeGirlId:function(girl_name){
            var girl_id;
            if(girl_name=="premium"){
                girl_id=0;
            }
            else{
                girl_id=$.takeGirlId(girl_name);
            }
            return girl_id;
        },
        findAnimKey:function(girl_name){
            var girl_id_tmp;
            var anim_key,bum,cur_key=-1;
            var k;
            var have_anim=0;
            var anim_len=0;
            for(anim_key=0;anim_key<conf_anim.length;anim_key++){
                bum=conf_anim[anim_key];
                if(in_array(girl_name,bum.girl_names)){
                    have_anim=1;
                    for(k in bum.girl_names){
                        girl_id_tmp=this.takeGirlId(bum.girl_names[k]);
                        if(!in_array(girl_id_tmp,from_php.girl_ids)){
                            have_anim=0;
                        }
                    }
                    if(have_anim==1 && bum.girl_names.length>anim_len){
                        anim_len=bum.girl_names.length;
                        cur_key=anim_key;
                        
                    }
                }
            }
            return cur_key;
        },
        centerGirl:function(girl_id){
            
            var girl_name="premium";
            if(girl_id){
               girl_name=$.takeGirlImage(girl_id);
            }
            var conf=conf_all[girl_name];
            var pos=[-conf.pos[0],-conf.pos[1]];
            pos[0]+=1280/2-conf.size[0]/2;
            pos[1]+=780/2-conf.size[1]/2;
            
            var i;
            for(i=0;i<2;i++){
                pos[i]=Math.max(pos[i],this.range_all[i]);
                pos[i]=Math.min(pos[i],0);
            }
            this.x=pos[0];
            this.y=pos[1];
        },
        clickOne:function(pos){
            var girl_name,bum,choose="";
            var pos_poly;
            for(girl_name in conf_all){
                bum=conf_all[girl_name];
                if(
                    pos[0]>bum.pos[0] && pos[0]<bum.pos[0]+bum.size[0] 
                    &&
                    pos[1]>bum.pos[1] && pos[1]<bum.pos[1]+bum.size[1]
                    &&
                    in_array(this.takeGirlId(girl_name),from_php.girl_ids)
                ){
                    pos_poly=[pos[0]-bum.pos[0]-bum.size[0]/2,pos[1]-bum.pos[1]-bum.size[1]/2];
                    var poly=new PIXI.Polygon(dobleanim_takemap(girl_name));
                    if(poly.contains(pos_poly[0],pos_poly[1])){
                        if(zoomCur.showGirl(girl_name)){
                            textObj.afterClick();
                            break;
                        }
                    }
                    
                }
            }
            
            
        },
        prepareMove:function(){
            var can_move=0,pos_start=[0,0];
            
            var qpos=[this.range_all[0]/2,this.range_all[1]/2];
            var click_pos=[0,0];
            
            
            var thc=this;
            
            
            function qStart(pos){
                if(can_move==0 && zoomCur.current_state=="all"){
                    pos_start=copyArray(pos);
                    click_pos=copyArray(pos);
                    can_move=1;
                }
            }
            function qMove(pos){
                
                var i;
                
                if(can_move && zoomCur.current_state=="all"){
                    qpos=[thc.x,thc.y];
                    
//                    thc.x=qpos[0];
//                    thc.y=qpos[1];
                    for(i=0;i<2;i++){
                        qpos[i]=qpos[i]-(pos_start[i]-pos[i])*2;
                        qpos[i]=Math.max(qpos[i],thc.range_all[i]);
                        qpos[i]=Math.min(qpos[i],0);
                    }
                    
                    thc.x=qpos[0];
                    thc.y=qpos[1];
                    textObj.afterClick();
                    pos_start=copyArray(pos);
                }
            }
            function qEnd(){
                can_move=0; 
                if(lengthVectorPow(minusVector(pos_start,click_pos))<200 && zoomCur.current_state=="all"){
                    thc.clickOne([click_pos[0]-thc.x,click_pos[1]-thc.y]);
                }
            }
            
            
            canvWrap.on("mousemove",function(e){
                qMove([$.getXeventOffset(e),$.getYeventOffset(e)]);
            }).on("mousedown",function(e){
                qStart([$.getXeventOffset(e),$.getYeventOffset(e)]);
            }).on("mouseup",function(){
                qEnd();
            });
            var touchObj=new addTouch(canvWrap[0],{
                onStart:function(arr){
                    qStart(arr[0]);
                },
                onMove:function(arr){
                    qMove(arr[0]);
                },
                onEnd:function(){
                    qEnd();
                },
            });
            
        },
        test:function(){
            var i,obj;
            for(i in conf_all){
                if(i!="def"){
                    obj=conf_all[i];
                    var graphics = new PIXI.Graphics();
                    // set the line style to have a width of 5 and set the color to red
                    graphics.lineStyle(1, 0xFF0000);

                    // draw a rectangle
                    graphics.drawRect(obj.pos[0], obj.pos[1], obj.size[0], obj.size[1]);

                    this.addChild(graphics);
                }
            }
            
        },
        myUpdate:function(delta){
            var i;
            for(i in this.girlObjSet){
                this.girlObjSet[i].myUpdate(delta);
            }
        }
    });    
    function textOne(){
        var txt=from_php.lang_howto;
        if(!txt){
            txt="";
        }
        txt=txt.replace("<br>","\n");
        myPixiObj.showText.call(this,txt,{
            font_color:"#ffffff",
            font_size:30,
            pos:[640,720],
            "border_color":"#31153f",
            border_size:3,
            anchor:[0.5,1]
        });
    }
    textOne.prototype = Object.create(myPixiObj.showText.prototype);
    textOne.prototype=$.extend(textOne.prototype,{
        afterClick:function(){
            this.step_max=30;
            this.step_max_fadeout=30;
        }
    });
    
    
    loaderMain.load(function(loader, resourcesQ){
        
        resources=resourcesQ;
        
        mapCur=new mapWalk({});
        mapCur.init();
        app.stage.addChild(mapCur);
        
        textObj=new textOne();
        app.stage.addChild(textObj);
        
        
        zoomCur=new mapZoom({});
        app.stage.addChild(zoomCur);
        
        
        
        
        
        
//        mapCur.test();
        
        $.triggerPlacePreloader(1);
        loaderSemaphore.clear();
        wasLoaded=1;
        
        app.ticker.add(
            function(delta){
                mapCur.myUpdate(delta);
                zoomCur.myUpdate(delta);
                textObj.update(delta);
            }    
        );

        main.find("#suitButton").click(function(){
            mapCur.toggleSuits();
        });
        
        //zoomCur
    });
    
    main.find("#exitJS").click(function(){
        $.goToLocation(from_php.link);
    });
    
    
    
    _moduleEvents.one("moduleClear",function(){
        if(typeof app!="undefined" && app!=null){
            app.destroy();
        }
        if(typeof loaderMain.reset!="undefined"){
            loaderMain.reset();
        }
    });
    $.handleBottomMenu();
}